var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gc-table',{attrs:{"showPage":false,"border":"","columns":_vm.columns,"table-data":_vm.tableData}})}
var staticRenderFns = []

export { render, staticRenderFns }